import {GoToDetail} from 'components/grid-dx/consult-buttons';
import IntegrityRoleGrid from 'components/UserRole';
import {Column} from 'devextreme-react/data-grid';
import React from 'react';
import {i18n2} from '../../i18n/i18n';
import {SectorSchema} from '../../sectors/model/Sector';
import useLoadSectorAdditional from '../hooks/useLoadSectorAdditional';
import {useIsTablet} from 'components/hooks/useIsTablet';
import {
  useActionButtonStyles,
  getActionColumnWidth,
} from 'components/grid-dx/styles/actionButtonStyles';

interface ButtonsProps {
  data: any;
  props: any;
}

const Buttons = ({data, props}: ButtonsProps) => {
  const id = props.key;
  const isTablet = useIsTablet();
  const styles = useActionButtonStyles();
  return (
    <div
      className={isTablet ? styles.tabletContainer : styles.compactContainer}>
      <GoToDetail data={data} id={id} url={'/ReadStagesBySectorDetails'} />
    </div>
  );
};

const SectorsReadOnly = () => {
  const loadSectors = useLoadSectorAdditional('SectorReadOnly');
  const isTablet = useIsTablet();

  const getTotalPending = (rowData: any) => rowData.totalPending || 0;

  return (
    <IntegrityRoleGrid
      schema={SectorSchema(true)}
      dataSource={loadSectors}
      id={['iD_Sector']}
      allowActions={false}
      allowIntegrity={false}
      exportName="Sector-consult-export">
      <Column
        caption={i18n2._('#Sector')}
        hidingPriority={0}
        dataField="iD_Sector"
        visible={false}
      />
      <Column
        caption={i18n2._('Nombre')}
        defaultSortOrder={'asc'}
        dataField="name"
        width="70%"
      />
      <Column
        caption={i18n2._('Capacitaciones pendientes')}
        calculateCellValue={(rowData: any) => getTotalPending(rowData)}
        width="20%"
      />
      <Column
        caption=""
        cellComponent={(e: any) => (
          <Buttons data={e.data.data} props={e.data} />
        )}
        width={getActionColumnWidth(1, isTablet)}
        fixed
        alignment="right"
      />
    </IntegrityRoleGrid>
  );
};

export default SectorsReadOnly;
